import isEqual from 'lodash/isEqual'
import debounce from 'lodash/debounce'
import { mapState } from 'vuex'
import { SET_ORDER, SET_IDS } from '@/store/modules/sort'

function sort (ids, entities, property, order) {
  return ids.slice().sort((a, b) => {
    let valA = entities[a][property]
    let valB = entities[b][property]
    if (order === 'desc') {
      [valA, valB] = [valB, valA]
    }
    return valA < valB ? -1 : valA > valB ? 1 : 0
  })
}

export default {
  props: {
    label: String,
    prop: String,
    width: String,
    formatter: Function,
    collectionName: String
  },

  computed: {
    ...mapState({
      direction (state) {
        const sort = state[this.collectionName].sort
        return sort.property === this.prop
          ? sort.direction === 'asc' ? 'ascending' : 'descending'
          : ''
      },
      currentSort (state) {
        return state[this.collectionName].sort
      },
      collectionIds (state) {
        const cs = state[this.collectionName]
        return cs.search ? cs.search.ids : cs.ids
      },
      collectionEntities (state) {
        return state[this.collectionName].entities
      }
    })
  },

  methods: {
    sort (direction) {
      this.$store.commit(this.collectionName + '/sort/' + SET_ORDER, {
        property: this.prop,
        direction: direction
      })
      this.updateSortIds()
    },
    updateSortIds: debounce(function () {
      const ids = sort(this.collectionIds, this.collectionEntities, this.currentSort.property, this.currentSort.direction)
      if (!isEqual(ids, this.currentSort.ids)) {
        this.$store.commit(this.collectionName + '/sort/' + SET_IDS, ids)
      }
    }, 0),
    sortableHeader (h, { column }) {
      return [
        column.label,
        h('span', {
          'class': ['caret-wrapper', this.direction]
        }, [
          h('i', {
            attrs: { class: 'sort-caret ascending' },
            on: { click: () => this.sort('asc') }
          }),
          h('i', {
            attrs: { class: 'sort-caret descending' },
            on: { click: () => this.sort('desc') }
          })
        ])
      ]
    }
  },

  watch: {
    collectionIds () {
      this.updateSortIds()
    }
  },

  render (h) {
    return h('el-table-column', {
      props: {
        label: this.label,
        prop: this.prop,
        width: this.width,
        formatter: this.formatter,
        renderHeader: this.sortableHeader
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/SortableColumn.js